import {
  formatLocalElectionOfficeLink,
  hasEarlyVoting,
  electionsByMailOnly,
  idSummaries,
} from '~utils/faqAnswerUtils';

export const canIVoteEarly = (stateInfo, stateName, stateCode) => {
  if (!hasEarlyVoting(stateInfo)) {
    return `${stateName} does not offer a statewide early voting program. 
    However, if you are unable to vote on Election Day, you can vote with an absentee ballot.
    [Check with your state for more information](${stateInfo.source_absentee_info.text}).`;
  }

  const paragraphs = [];
  paragraphs.push(`Yes, early voting is available in ${stateName}.`);

  if (stateInfo.early_voting_starts.text.toLowerCase().includes('varies')) {
    paragraphs.push(
      `Dates vary by location. Check with your ${formatLocalElectionOfficeLink(
        stateCode
      )} for details about your area.`
    );
  } else {
    const bullets = [];
    bullets.push(`* It starts ${stateInfo.early_voting_starts.text}.`);
    bullets.push(`* It ends ${stateInfo.early_voting_ends.text}.`);

    if (stateInfo.gov_tool_polling_place.text) {
      bullets.push(
        `* [Find early voting locations here](${stateInfo.gov_tool_polling_place.text}).`
      );
    }

    paragraphs.push(bullets.join('\n'));
  }

  return paragraphs.join('\n\n');
};

export const whereDoIVote = (stateInfo, stateName, stateCode) => {
  if (stateInfo.gov_tool_polling_place.text) {
    return `Find your polling place${
      hasEarlyVoting(stateInfo) ? ' and early voting locations' : ''
    } 
    using the [${stateName} polling place locator](${
      stateInfo.gov_tool_polling_place.text
    }).`;
  }

  return `Contact your ${formatLocalElectionOfficeLink(
    stateCode
  )} if you need help finding your polling place.`;
};

export const whatDoINeedToBringToThePolls = (stateInfo) => {
  const paragraphs = [];
  paragraphs.push(idSummaries[stateInfo.id_type_in_person_voting.text]);
  paragraphs.push(stateInfo.id_laws_in_person_voting.text);
  return paragraphs.join('\n\n');
};

export const canIUseStudentId = (stateInfo) => {
  return stateInfo.id_laws_student_voters.text;
};

export const howDoIKnowIfMyProvisionalBallotWasCounted = (
  stateInfo,
  stateName,
  stateCode
) => {
  const howToCheckPhrase = stateInfo.gov_tool_provisional_tracker.text
    ? `use the [${stateName} provisional ballot tracker tool](${stateInfo.gov_tool_provisional_tracker.text})`
    : `contact your ${formatLocalElectionOfficeLink(stateCode)}`;

  return `If you had to cast a provisional ballot on Election Day (rather than a normal ballot), you can 
  ${howToCheckPhrase} to find out if it was accepted.`;
};

export const canIVoteInPerson = (stateInfo, stateName, stateCode) => {
  if (electionsByMailOnly.includes(stateCode)) {
    const paragraphs = [];
    paragraphs.push(`No. Elections in ${stateName} are held entirely by mail. 
    This means that ${stateName} will automatically send a mail-in ballot to 
    every registered voter ahead of all elections.`);
    paragraphs.push(
      `If you have questions about this process, contact your ${formatLocalElectionOfficeLink(stateCode)}.`
    );

    return paragraphs.join('\n\n');
  }

  return `Yes. ${whereDoIVote(stateInfo, stateName, stateCode)}`;
};
